import { Button, Heading, UseModalProps, VStack } from '@masterplandev/ui'

import useTranslation from '@/core/hooks/useTranslation'

type PollFormCompletedProps = {
  children?: React.ReactNode
  onClose: UseModalProps['onClose']
}

export function PollFormCompleted({
  children,
  onClose,
}: PollFormCompletedProps) {
  const { translate } = useTranslation('poll-form-completed')
  if (children) {
    return children
  }

  return (
    <VStack gap="6" mt="25vh">
      <Heading as="h4" size={['h4', 'h3']}>
        {translate('title')}
      </Heading>
      <Button size="lg" onClick={onClose}>
        {translate('button')}
      </Button>
    </VStack>
  )
}
